import { PreferredView, UserType } from '@/modules/user/types';
import * as actions from './actions';
import { type UserState } from './state';

export const DEFAULT_PREFERRED_VIEW = PreferredView.Overview;

export const userStore = {
  namespaced: true,
  actions,
  state: {
    type: UserType.practitioner,
    origin: null,
    preferredView: DEFAULT_PREFERRED_VIEW
  } as UserState,
  mutations: {
    setOrigin(state: UserState, origin: string | null) {
      state.origin = origin;
    },
    setPreferredView(state: UserState, preferredView: PreferredView | null | undefined) {
      state.preferredView = Object.values(PreferredView).includes(preferredView as PreferredView)
        ? (preferredView as PreferredView)
        : DEFAULT_PREFERRED_VIEW;
    }
  },
  getters: {
    isThirdPartyOrigin: (state: UserState): boolean => state.origin !== null,
    getPreferredView: (state: UserState): PreferredView =>
      state.preferredView ?? DEFAULT_PREFERRED_VIEW
  }
};
